import moment from 'moment';

import type {
  RecordDetailsForm,
  Service,
} from '@app/components/RecordModal/components/RecordDetails/types';
import {
  getManualDurationDelta,
  getServicesTotalDuration,
  getTotalDurationWithManualDelta,
} from '@app/components/RecordModal/components/RecordDetails/utils';

interface GetServicesDurationFieldsProps {
  /** Строки «Услуг» после правки */
  nextServices: Service[];
  /** Строки «Услуг» до правки — от них считается ручная надбавка времени */
  previousServices: Service[];
  durationHour: number;
  durationMinute: number;
  timeStart: string;
}

/**
 * Длительность и конец записи после правки услуг. Ручная надбавка к сумме
 * длительностей услуг сохраняется. Без услуг длительность не меняется.
 */
export const getServicesDurationFields = ({
  nextServices,
  previousServices,
  durationHour,
  durationMinute,
  timeStart,
}: GetServicesDurationFieldsProps): Pick<
  RecordDetailsForm,
  'DurationHour' | 'DurationMinute' | 'TimeEnd'
> => {
  const currentTotalDuration = durationHour * 60 + durationMinute;
  const servicesMinutes = getServicesTotalDuration(nextServices);
  const prevServicesTotalDuration = getServicesTotalDuration(previousServices);
  const manualDurationDelta =
    prevServicesTotalDuration === 0
      ? 0
      : getManualDurationDelta(currentTotalDuration, previousServices);
  const fullMinutes = getTotalDurationWithManualDelta(
    nextServices,
    manualDurationDelta
  );

  const isEmptyFullMinutes = servicesMinutes === 0;

  const hours = isEmptyFullMinutes
    ? durationHour
    : Math.floor(fullMinutes / 60);
  const minutes = isEmptyFullMinutes
    ? durationMinute
    : fullMinutes - hours * 60;

  const timeEnd = moment(timeStart, 'HH:mm')
    .add(hours, 'hours')
    .add(minutes, 'minutes')
    .format('HH:mm');

  return {
    DurationHour: hours,
    DurationMinute: minutes,
    TimeEnd: timeEnd,
  };
};
